import { combineReducers } from 'redux';
import {
  SET_IMAGE_ELEMENT_FILE_INFO,
  SET_IMAGE_ELEMENT_URL,
  SET_IMAGE_ELEMENT_WIDTH,
  SET_IMAGE_ELEMENT_HEIGHT,
  SET_IMAGE_ELEMENT_ALIGN,
} from '../actions/action-names';

const fileInfo = (state = {}, action) => {
  switch (action.type) {
    case SET_IMAGE_ELEMENT_FILE_INFO:
      return Object.assign({}, state, action.value);
    default:
      return state;
  }
};

const url = (state = '', action) => {
  switch (action.type) {
    case SET_IMAGE_ELEMENT_URL:
      return action.value;
    default:
      return state;
  }
};

const width = (state = '', action) => {
  switch (action.type) {
    case SET_IMAGE_ELEMENT_WIDTH:
      return action.value;
    default:
      return state;
  }
};

const height = (state = '', action) => {
  switch (action.type) {
    case SET_IMAGE_ELEMENT_HEIGHT:
      return action.value;
    default:
      return state;
  }
};

const align = (state = '', action) => {
  switch (action.type) {
    case SET_IMAGE_ELEMENT_ALIGN:
      return action.value;
    default:
      return state;
  }
};

export default combineReducers({
  fileInfo,
  url,
  width,
  height,
  align,
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/image-element-options-reducers.js